import React from 'react';
import { useState, useRef, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import { ReactSession } from 'react-client-session';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { LocalizationContext } from '../App';
import { useMediaQuery } from 'react-responsive';
import { Divider } from '@mui/material';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CardActionArea, CardActions } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

const LoupeSettings = (props) => {

    ReactSession.setStoreType("localStorage");

    if( ReactSession.get("location_watch") === undefined ) {
        ReactSession.set("location_watch", "true" );
    }

    const userHistory = JSON.parse(ReactSession.get("userHistory"));


    const [rerender, setRerender] = useState(false);

    const [items, setItems] = useState({        
        location_watch : ReactSession.get("location_watch") == "true" ? true : false,
    });

    function handleUpdates(event, key) {                
        items[key] = event.target.checked;
        ReactSession.set(key, event.target.checked ? "true" : "false" );     
        setRerender(!rerender);
    }

    const [ tabValue, setTabValue ] = React.useState(0);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    }

    function TabPanel(props) {
        const { children, value, index, ...other } = props;
      
        return (
          <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
          >
            {value === index && (
              <Box sx={{ padding : "3px" }}>
                <>{children}</>
              </Box>
            )}
          </div>
        );
      }
      
      TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
      };

      function a11yProps(index) {
        return {
          id: `simple-tab-${index}`,
          'aria-controls': `simple-tabpanel-${index}`,
        };
      }

    return (
        <LocalizationContext.Consumer>
           {
               ({strings}) => 
                
               <Paper className="padding">
                   <div>

                        <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
                            <Tab label={strings.getString("texts.settings.history")} {...a11yProps(0)}/>
                            <Tab label={strings.getString("texts.settings.settings")} {...a11yProps(1)}/>
                            <Tab label="Info" {...a11yProps(2)}/>
                        </Tabs>
                    
                        <TabPanel value={tabValue} index={0}>
                            <Paper className="padding">
                                <Typography gutterBottom component="div" variant="caption"> {strings.getString("texts.settings.historyPromise")}</Typography>
                                { userHistory.length > 0 && userHistory.map(i => {
                                    return(
                                        <>
                                            <Typography component="div" variant="body2">{i.ActivityTitle}</Typography>
                                        </>
                                    )
                                })}
                            </Paper>
                        </TabPanel>

                        <TabPanel value={tabValue} index={1}>
                            <Paper className="padding">
                                <FormGroup>
                                    <FormControlLabel className="text-start" control={<Switch checked={items["location_watch"]} onChange={(event) => {handleUpdates(event, "location_watch")} }/>} label={strings.getString("controls.settings.watch")} />                           
                                </FormGroup>
                            </Paper>
                        </TabPanel>
                       
                        <TabPanel value={tabValue} index={2}>
                            <Paper className="padding">
                                <Typography gutterBottom component="div" variant="caption">App-Version {process.env.REACT_APP_VERSION}</Typography>
                                <Typography gutterBottom component="div" className="mb-6" variant="caption">LOUPE, loupesight.city &copy; 2021&#8212;2022, Sebastian Scheuer, Daniel Wienhöfer, Jessica Jache.</Typography>
                            </Paper>
                        </TabPanel>

                   </div>
               </Paper>
            
           } 
        </LocalizationContext.Consumer>
    );
}
export default LoupeSettings;